<template>
  <div>
    <div v-if="loading">
      <loading-animation />
    </div>

    <div v-else>

      <p>
        <b>Pedidos de origem:</b>
      </p>

      <div v-if="!relatedOrders || !relatedOrders.length" class="mb-3">
        <div class="row bg-light mx-0 py-3">
          <div class="col text-center">Este pedido não possui nenhum pedido relacionado</div>
        </div>
      </div>

      <div
        v-for="(relatedOrder, index) in relatedOrders || []"
        :key="'related_order_' + index"
        class="row py-1 border align-items-center "
        :class="{ 'bg-light': index % 2 != 0 }"
      >
        <div class="col">
          <div class="row">

            <div class="col-xl col-sm-4">
              <b>Número: </b> {{ relatedOrder.number || relatedOrder.documentNumber }}
            </div>
            <div class="col-xl col-sm-4">
              <b>Transação: </b> {{ relatedOrder.ref }}
            </div>
            <div class="col-xl col-sm-4">
              <b>Situação: </b> {{ relatedOrder.status }}
            </div>
            <div class="col-xl col-lg-4 col-12">
              <b>Status interno: </b> {{ getMovementStatusLabel(relatedOrder.movementStatus) }}
            </div>
            <div class="col">
              <b>Data: </b> {{ formatDate(relatedOrder.createdAt) }}
            </div>

          </div>
        </div>

        <div class="col-auto">
          <b-button
            variant="info"
            @click="searchOrder(relatedOrder)"
          >
            <i class="fa fa-search mr-1"></i> Procurar
          </b-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { httpClient } from '@/service'
import { LoadingAnimation } from "@/components/loaders";
import shared from '@/shared/shared';

export default {
  name: 'related-orders-table',
  components: {
    LoadingAnimation
  },

  props: {
    order: {
      type: Object,
      require
    }
  },

  data() {
    return {
      loading: false,
      relatedOrders: []
    }
  },

  mounted() {
  },

  methods: {
    load() {
      this.loading = true;
      httpClient.get(
        `${process.env.VUE_APP_API_URL}related-orders/target/${this.order.id}`
      ).then(({ data }) => {
        this.loading = false;
        this.relatedOrders = data.data || [];
      }).catch((error) => {
        this.loading = false;
        if (error.message) {
          this.$notify.error(error)
        }
      });
    },

    formatDate(date) {
      return shared.formatDate(date);
    },

    getMovementStatusLabel(status) {
      return shared.getMovementStatusLabel(status);
    },

    searchOrder(order) {
      let url = new URL(window.location.href);

      url.searchParams.set('searchText', order.ref || order.number || order.documentNumber || order.id);
      url.searchParams.set('tab', 'pending');

      window.open(url.toString(), '_blank', 'noopener');
    }
  }
}
</script>

<style>
</style>
